import createReactClass from "create-react-class";

export default function() {
    const html = createReactClass({
        render() {
            return null;
        },
        componentWillReceiveProps(props) {
            setValue(this.props.field, props.globalState);
        },
        componentWillMount() {
            setValue(this.props.field, this.props.globalState);
        }
    });

    return {
        html,
        config: {
            invisible: true,
        },
    };
};

function setValue({config, state}, globalState) {
    var {ref, stateKey} = config;
    var remoteState = globalState?.fullState?.[ref]?.[stateKey];
    if (remoteState !== null || remoteState !== undefined) {
        state.value = remoteState;
    }
    else state.value = "";
}


